import { getCurrentSchoolYearRange } from "../../helper";

const QUICK_FILTER_LABELS = {
  phantomContracts: "Phantom",
  canceledContracts: "Cancelled",
  needBarCalc: "Need for calc",
  requireReconciliation: "Needs reconciliation",
  sentSigned: "Sent + signed",
  inProgressSigned: "In progress + signed",
  othersWithNoSignDate: "No sign date",
  potentialDuplicates: "Potential duplicates",
  exactDuplicates: "Exact duplicates",
  signedBeforeCreation: "Signed before creation",
  signedAfterEvent: "Signed after event",
};

// Filters are saved per user and restored on the next login, so a pin left on
// weeks ago still narrows a table with nothing on screen to say so. This lists
// what is actually narrowing the list. The school-year range is the default
// view, so it only counts once someone moves it.
//
// Shared by the child (Contracts) and parent (Parent Contracts) tables. The
// parent filter only carries a subset of these keys, and the absent ones are
// simply never set, so the same function covers both.
export const getActiveFilters = (filter) => {
  if (!filter) return [];

  const isSet = (value) =>
    Array.isArray(value)
      ? value.length > 0
      : value !== "" && value !== null && value !== undefined && value !== false;

  // getCurrentSchoolYearRange returns Date objects while a saved filter holds
  // date strings, so comparing the two with !== compares a string against an
  // object and is always true. Compare the calendar day instead.
  const isSameDay = (a, b) => {
    const left = new Date(a);
    const right = new Date(b);
    if (Number.isNaN(left.getTime()) || Number.isNaN(right.getTime())) return false;
    return (
      left.getFullYear() === right.getFullYear() &&
      left.getMonth() === right.getMonth() &&
      left.getDate() === right.getDate()
    );
  };

  const [schoolYearStart, schoolYearEnd] = getCurrentSchoolYearRange();
  const chips = [];

  if (isSet(filter.client)) {
    const count = Array.isArray(filter.client) ? filter.client.length : 1;
    chips.push(`Client (${count})`);
  }
  if (isSet(filter.clientType)) chips.push("Client type");
  if (isSet(filter.soldBy)) chips.push("Sold by");
  if (isSet(filter.createdBy)) chips.push("Created by");
  if (isSet(filter.schoolRegion)) chips.push("School / region");
  if (isSet(filter.contractStatus)) chips.push("Status");
  if (isSet(filter.isInvoiced)) chips.push("Invoiced");
  if (isSet(filter.search)) chips.push(`Search "${filter.search}"`);

  const eventDatesMoved =
    (isSet(filter.startEventDate) &&
      !isSameDay(filter.startEventDate, schoolYearStart)) ||
    (isSet(filter.endEventDate) && !isSameDay(filter.endEventDate, schoolYearEnd));
  if (eventDatesMoved) chips.push("Event date");
  if (isSet(filter.startSignDate) || isSet(filter.endSignDate)) chips.push("Sign date");
  if (isSet(filter.startCreatedDate) || isSet(filter.endCreatedDate))
    chips.push("Created date");

  if (isSet(filter.minTotalCost) || isSet(filter.maxTotalCost)) chips.push("Cost");
  if (isSet(filter.minClientBudget) || isSet(filter.maxClientBudget)) chips.push("Budget");
  if (isSet(filter.minProfit) || isSet(filter.maxProfit)) chips.push("Profit");
  if (isSet(filter.minProfitPercentage) || isSet(filter.maxProfitPercentage))
    chips.push("Profit %");

  Object.entries(QUICK_FILTER_LABELS).forEach(([key, label]) => {
    if (isSet(filter[key])) chips.push(label);
  });

  return chips;
};
